import { Component, Vue } from 'vue-property-decorator'

import Loader from '@/components/Loader/index.vue'
import ModalDeadline from '@/components/edit/ModalDeadline/index.vue'
import CardDeadline from '@/components/CardDeadline/index.vue'
import YearMonthList from './YearMonthList/index.vue'
import ModalAuditoriaEdit from './ModalAuditoriaEdit/index.vue'
import { bus } from '@/main'
import api from '@/helpers/fetch'

@Component({
	components: {
		Loader,
		CardDeadline,
		ModalDeadline,
		YearMonthList,
		ModalAuditoriaEdit,
	},
})
export default class MyTasks extends Vue {
	loading = false
	emailLogs = [] as any[]
	auditorias = [] as any[]
	selectedAuditoria: any = null

	async reloadAuditorias() {
		const res = await api.get(`/api/my-account/tasks/audits`)
		this.auditorias = res.data || []
	}

	get userFirstName() {
		return JSON.parse(localStorage.getItem('user')!).name.split(' ')[0]
	}

	get tasks() {
		const mappedDeadlines =
			this.$store.state.deadlines.deadlines?.map((deadline) => {
				return { ...deadline, deadline }
			}) || []

		const mappedAuditorias = this.auditorias
			.filter((a) => a.response_deadline)
			.map((a) => ({
				componentType: 'CardAuditoria',
				auditoria: a,
				date: a.response_deadline,
			}))

		return [...mappedDeadlines, ...this.emailLogs, ...mappedAuditorias]
	}

	async mounted() {
		this.loading = true
		bus.$on('open-modal-deadline', (id) => {
			this.$store.dispatch('selectDeadlineId', id)
			this.$bvModal.show('modal-deadline')
		})
		bus.$on('open-modal-auditoria-edit', (auditoria: any) => {
			this.selectedAuditoria = auditoria
			this.$bvModal.show('modal-auditoria-edit')
		})

		const [, tasksRes, auditsRes] = await Promise.all([
			this.$store.dispatch('fetchMyDeadlines'),
			api.get(`/api/my-account/tasks`),
			api.get(`/api/my-account/tasks/audits`),
		])

		if (tasksRes?.data) this.emailLogs.push(...tasksRes.data)
		if (auditsRes?.data) this.auditorias.push(...auditsRes.data)

		this.loading = false
	}
}
